import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {collection, doc, getDoc, getFirestore} from "firebase/firestore"

const firebaseConfig = {
    apiKey: "AIzaSyCRpxe7vWmEsQXCOp5ici1NecfBf4SwlCk",
    authDomain: "jm-web-748d0.firebaseapp.com",
    projectId: "jm-web-748d0",
    storageBucket: "jm-web-748d0.appspot.com",
    messagingSenderId: "553771015733",
    appId: "1:553771015733:web:d691ed035d85df18281b7c",
    measurementId: "G-8LSRYB9K3X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore();


export default db;